module.exports = __webpack_public_path__ + "img/ic_log.9d470cb1.png";